import { useState } from 'react';
import {
  cn,
  Popover,
  PopoverButton,
  PopoverTrigger,
} from '@playerbase/ui';

import { STAGE_BADGE_CLASSES } from '../../games/stage-colour-classes.js';
import { useShell } from '../use-shell.js';
import { BuildPillDropdown } from './build-pill-dropdown.js';

// Topbar pill that anchors the BuildPillDropdown. Uses PopoverButton (size
// "sm") so it shares chrome styling with the milestone selector and the
// sidebar studio/game switchers — bordered, surface-2 fill, hover lift.
export function BuildPill(): JSX.Element | null {
  const { activeGame, activeBuildMarker, activeStage } = useShell();
  const [open, setOpen] = useState(false);

  if (activeGame === null) return null;

  const noBuild = activeBuildMarker === null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <PopoverButton
          size="sm"
          title={noBuild ? 'No build tagged yet — click to log one' : undefined}
          aria-label={
            noBuild
              ? 'Log a build'
              : `Build ${activeBuildMarker.label}${activeStage !== null ? ` · ${activeStage.label}` : ''}`
          }
        >
          <span className="font-mono">
            {noBuild ? 'No build yet' : activeBuildMarker.label}
          </span>
          {!noBuild && activeStage !== null && (
            <span
              // `leading-none` + tighter padding so the badge fits within
              // the pill's natural height — without it the badge's
              // line-height grew the button taller than the GameSwitcher.
              className={cn(
                'rounded-sm border px-1.5 py-px text-[10px] font-mono uppercase tracking-wider leading-none',
                STAGE_BADGE_CLASSES[activeStage.colour],
              )}
            >
              {activeStage.label}
            </span>
          )}
        </PopoverButton>
      </PopoverTrigger>
      <BuildPillDropdown onClose={() => setOpen(false)} />
    </Popover>
  );
}
